import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch } from 'react-router-dom';
import { toast } from 'react-toastify';

import Snack from '@/common/components/molecules/Snack/Snack';
import {
  ROUTE_404,
  ROUTE_SCANBAT,
  ROUTE_SCANBAT_CHECKOUT,
  ROUTE_SCANBAT_CHECKOUT_CONFIRM,
  ROUTE_SCANBAT_PRODUCT,
} from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';
import PrivateRoute from '@/common/router/PrivateRoute';
import Product from '@/ebat/components/blocks/Modal/Scanbat/Product/Product.container';

import Checkout from './Checkout/Checkout.container';
import CheckoutConfirm from './CheckoutConfirm/CheckoutConfirm.container';
import Scanbat from './Scanbat.container';

const ScanbatRouter = () => {
  const { user, logout } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    if (!user?.functionality_accesses?.scanbat_connect) {
      logout();
      toast.error(
        <Snack
          message={t('common:messages:login.authentication.not_allowed')}
        />,
      );
    }
  }, [logout, t, user]);

  return (
    <Switch>
      <Route path={ROUTE_SCANBAT} exact>
        <Scanbat />
      </Route>
      <Route path={ROUTE_SCANBAT_CHECKOUT} exact>
        <Checkout />
      </Route>
      <Route path={ROUTE_SCANBAT_CHECKOUT_CONFIRM} exact>
        <CheckoutConfirm />
      </Route>
      <Route path={`${ROUTE_SCANBAT_PRODUCT}/:id`} exact>
        <Product />
      </Route>
      <PrivateRoute>
        <Redirect to={ROUTE_404} />
      </PrivateRoute>
    </Switch>
  );
};

export default ScanbatRouter;
